const fcCloudVolumeContractModelEA_SCE_MPSA = `
    <table align="center" cellpadding="0" cellspacing="0" width="600" style="border-collapse: collapse;">
    <tr>
    <td align="center" height='100px'>
        <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS
            DE LICENCIAMENTO </strong></p>
    </td>
    </tr>
    <br />
    <tr>
    <td>
        <br />
        <p>
        Pelo presente instrumento particular, em que são partes, {{companyname}}, com sede na {{companyaddress}}, nº
        {{companynumber}}, bairro {{companydistrict}}, {{companycity}}/{{companystate}}, inscrita no CNPJ/MF sob o nº
        {{companycnpj}}, neste ato devidamente representada por seu estatuto ou contrato social, doravante denominada
        CONTRATANTE e de outro lado, FCAMARA CONSULTORIA E FORMAÇÃO EM INFORMÁTICA LTDA., inscrita no CNPJ/MF sob o nº
        03.775.758/0001-90, estabelecida à Rua Bela Cintra, nº 986, 2º andar, CEP: 01415-000 - Consolação - São
        Paulo/SP, neste ato devidamente representada, em conformidade com seu Contrato Social, por seu representante
        legal infra-assinado, doravante denominada CONTRATADA.
        </p>
        <p>
        As Partes de comum acordo e por meio de seus representantes legais infra-assinados resolvem firmar o presente
        CONTRATO DE PRESTAÇÃO DE SERVIÇOS (“Contrato”), que se regerá segundo as cláusulas e condições a seguir
        previstas:
        </p>

        <p>
        <strong> Considerando que a FCAMARA: </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            <strong> (i) </strong> &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            É uma empresa especializada na prestação dos serviços de suporte e configuração de software (“Serviços”),
            detendo todo o know-how e a proficiência técnica;
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            <strong> (ii) </strong> &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Declara estar habilitada pela Microsoft a sublicenciar softwares desta fabricante;
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            <strong> (iii) </strong> &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Auxiliará a CONTRATADA em todo o processo de contratação dos serviços com a Microsoft.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA PRIMEIRA – DO OBJETO </strong>
        </p>


        <p>
        <table>
        <tr>
            <td valign=top>
            1.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O presente Contrato tem por objeto disciplinar a contratação, pela CONTRATANTE, da CONTRATADA, para
            Prestação de Serviços de Licenciamento, em conformidade com a Proposta Comercial anexa.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            1.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Os serviços contemplados por este instrumento estão descritos de forma detalhada, com as demais
            características inerentes à prestação de serviços objetivada, na Proposta Comercial anexa a este
            instrumento. As Partes acordam que caso haja divergência entre qualquer disposição prevista na Proposta
            Comercial e este Contrato, prevalecerá o previsto neste Contrato.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA SEGUNDA – DAS OBRIGAÇÕES DA CONTRATADA </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            2.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>
                Durante o prazo de vigência deste Contrato, e sem prejuízo das demais obrigações assumidas, a CONTRATADA
                obriga-se a:
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    a) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Operar como uma organização completa e independente da CONTRATANTE, fornecendo todo o material,
                    mão-de-obra, ferramentas e equipamentos necessários à execução dos serviços abrangidos pelo Contrato,
                    com exceção daqueles expressamente previstos em contrário neste instrumento ou na Proposta Comercial
                    como de obrigação da CONTRATANTE;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    b) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Planejar, conduzir e executar os serviços objeto do Contrato, com integral observância às disposições
                    e especificações deste instrumento e eventuais Propostas Comerciais e determinações legais;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    c) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Cumprir durante a execução dos serviços, todas as leis, regulamentos ou posturas federais, estaduais
                    ou municipais vigentes, bem como providenciar a obtenção das licenças, alvarás e autorizações
                    necessárias à regular a prestação dos serviços de que ora se trata;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    d) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Comunicar à CONTRATANTE, tão logo seja de seu conhecimento, sobre qualquer mudança nos procedimentos
                    fiscais internos que possam ter reflexo financeiro sobre este Contrato;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    e) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Auxiliar a CONTRATANTE em toda a intermediação dos serviços contratados pelo presente contrato com a
                    Microsoft.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>



        <p>
        <strong> CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DA CONTRATANTE </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            3.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Fornecer à CONTRATADA as informações, dados técnicos, documentos e pessoal indispensáveis à execução do
            objeto contratado. O cumprimento, pela CONTRATADA, dos prazos previstos no cronograma das atividades
            constantes da proposta técnica, exigirá o atendimento pela CONTRATANTE, no prazo requerido pela CONTRATADA,
            das solicitações de informações, dados técnicos, documentos e pessoal indispensáveis à execução do objeto
            contratado. Caso a CONTRATANTE, para atendimento das solicitações, não observe o prazo indicado pela
            CONTRATADA, esta estará autorizada a majorar, sem qualquer ônus, os prazos previstos no cronograma, em
            conformidade com o tempo de tal atraso.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            3.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Pagar, à CONTRATADA, pela prestação dos serviços, nos prazos e condições previstas neste Contrato e ou na
            Proposta Comercial e Anexos.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            3.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Indicar um ou mais colaboradores que se encarregarão de acompanhar os prepostos indicados pela CONTRATADA
            sempre que necessário à execução dos serviços. Da mesma forma, um elemento de contato será indicado como
            ponto focal para todos os assuntos envolvendo a contratação.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            3.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Ressaltando que a CONTRATANTE não está autorizada a fazer engenharia reversa, decompilar ou desmontar nenhum
            produto, separar e executar partes de um produto em mais de um dispositivo, atualizar nem fazer downgrade de
            partes de um produto em momentos diferentes, nem os usar para oferecer serviços de hospedagem.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            3.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Após o encerramento da competência do mês vigente da prestação de serviços e do término da execução dos
            serviços, a CONTRATANTE realizará o aceite tácito na fatura enviada referente aos valores apurados no que
            concerne à medição dos serviços prestados.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>


        <p>
        <strong> CLÁUSULA QUARTA – DO PREÇO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Pelos serviços contratados a CONTRATANTE pagará a CONTRATADA o valor correspondente e constante na Proposta
            Comercial anexa (Anexo I).
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.1.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Para a hipótese de contratação de acordo com o consumo da CONTRATANTE, conforme apurado pela Microsoft e
            informado à CONTRATADA, a cobrança será realizada no mês subsequente a prestação dos Serviços, podendo
            variar de acordo com a utilização, conforme cláusula 1ª e escopo exposto na proposta comercial anexa.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.1.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Já, em caso de contratos pré-pagos, o pagamento pela licença será de forma anual e referente aos 12 (doze)
            meses seguintes da quantia de licenças contratadas.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Ressalvada a hipótese de consumo igual à zero, caso em que a CONTRATANTE não será cobrada, ressaltando que
            não haverá valor mínimo para consumo.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            4.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Ficando desde já ciente que, caso a CONTRATANTE deseje adquirir mais produtos/serviços da Microsoft, poderá
            ocorrer uma alteração de valores, mediante consulta à tabela da Microsoft.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA QUINTA – DO PAGAMENTO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O pagamento do serviço prestado será efetuado mediante a apresentação de Nota Fiscal e fatura correspondente
            ao valor integral do ano completo (12 meses de prestação de serviço) ou de forma convencionada entre as
            Partes, concernente à Prestação de Serviços, pagável após 30 (trinta) dias da emissão da NF de Prestação de
            Serviços. Esse pagamento deverá ser efetuado por intermédio de crédito em conta corrente da CONTRATADA a ser
            previamente informada por escrito, servindo o recibo de depósito como comprovante de pagamento, ou por
            intermédio de boleto bancário, a ser enviado juntamente com a nota fiscal.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATANTE terá até 15 (quinze) dias após o recebimento das Notas Fiscais para realizar qualquer
            contestação sobre elas, caso não haja nenhuma contestação por parte da CONTRATANTE a fatura será assumida e
            incontestável.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O presente Contrato serve como título executivo extrajudicial para a cobrança dos valores devidos a título
            de multa, sendo consideradas dívidas líquidas e certas, passíveis de protesto e execução.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATADA é responsável por todos os tributos e taxas, sendo certo que todos já foram considerados no
            preço. Por ocasião dos pagamentos, a CONTRATADA providenciará a indicação, na Nota Fiscal de Serviços, para
            fins de retenção, de todos os tributos aplicáveis à espécie, cabendo o seu recolhimento pela parte
            Contribuinte, determinada em legislação específica.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Qualquer majoração dos tributos incidentes sobre o serviço objeto deste Contrato, e que ocorra durante a
            vigência dele, implicará, igualmente, na majoração proporcional do preço indicado nesta cláusula, majoração
            esta que será previamente informada pela CONTRATADA à CONTRATANTE.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.6 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O atraso do valor a ser pago obrigará a CONTRATANTE à quitação, além do valor principal indicado no
            documento fiscal encaminhado pela CONTRATADA, de juros de mora de 1% (um por cento) ao mês, multa de 2%
            (dois por cento) e atualização calculada pelo IPC-A pro rata temporis, calculados sobre a totalidade do
            débito vencido e não pago, desde a data do vencimento até a do efetivo pagamento.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            5.7 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A impontualidade, por parte da CONTRATANTE por mais de 30 (trinta) dias, desde que por sua culpa exclusiva,
            no pagamento de qualquer valor devido à CONTRATADA, constituirá infração contratual, podendo a CONTRATADA
            considerar rescindido o presente Contrato, cobrando todos os valores referentes a serviços já prestados e
            ainda não pagos, além disso, a CONTRATANTE terá os serviços contratados imediatamente interrompidos e poderá
            ter seu(s) título(s) protestado(s) e a inclusão nos órgãos de proteções de crédito.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>


        <p>
        <strong> CLÁUSULA SEXTA – DA VIGÊNCIA </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            6.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O prazo para a prestação dos serviços objeto deste Contrato é de 12 (doze) meses a contar da data de aceite
            do presente, sendo renovado apenas por meio de aditivo contratual.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA SÉTIMA – DA GARANTIA DOS SERVIÇOS </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATADA garante o objeto deste Contrato, pelo prazo legal de 60 (sessenta) dias a partir da data da
            entrega do serviço, devendo ser notificada pela CONTRATANTE acerca do problema encontrado.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>A garantia acima descrita está sujeita às seguintes limitações:</p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    I. &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    A garantia disposta na cláusula 7.1 não abrange problemas causados por uso indevido das soluções, bem
                    como customizações realizadas por terceiros de maneira inconsistente com o modo orientação ou melhor
                    técnica;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    II. &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    A garantia disposta na cláusula 7.1 não se aplica a problemas causados pela não observância dos
                    requisitos mínimos do sistema.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA OITAVA - DA NÃO SOLICITAÇÃO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            8.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Durante a vigência da contratação e pelo prazo de 1 (um) ano a contar do seu término, nenhuma das Partes
            poderá contratar funcionário(s), colaborador(es), e/ou prestador(ES) de serviço da outra, de forma direta ou
            indireta, nem tampouco lhe(s) fazer proposta(s) de trabalho, sem expressa anuência da outra parte. Em caso
            de não cumprimento dessa obrigação de NÃO FAZER, ficará resolvido de pleno direito o contrato existente
            entre as partes, devendo a parte infratora indenizar a outra no equivalente a 20 (vinte) vezes a remuneração
            percebida pelo(s) funcionário(s), colaborador(es), e/ou prestador(es) de serviço assediado(s) e/ou
            retirado(s) da equipe da Parte Inocente, além da indenização por perdas e danos provenientes da resolução
            contratual.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            8.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Para efeitos de cálculo da indenização mencionada nesta cláusula, a remuneração a ser adotada como base será
            aquela que o(s) funcionário(s), colaborador(es), e/ou prestador(es) de serviço obtiver na data da ocorrência
            do fato ou aquele constante em sua rescisão contratual, a que for maior. A base de cálculo será reajustada
            pelo IGP-M até o momento do pagamento da indenização.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA NONA – DO SIGILO E CONFIDENCIALIDADE </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes obrigam-se a manter o mais absoluto sigilo com relação a quaisquer dados pessoais e segredos
            comerciais, aos quais as Partes, ou qualquer de seus diretores, funcionários ou prepostos, venham a ter
            acesso, conhecimento ou que venham a lhes ser confiados em razão da celebração e execução deste Contrato,
            comprometendo-se, outrossim, a Parte que tiver acesso a tais informações, a não revelar, reproduzir,
            utilizar ou dar conhecimento, em hipótese alguma, a terceiros, bem como a não permitir que nenhum de seus
            diretores, funcionários, contratados, subcontratados e/ou prepostos faça uso indevido das mesmas.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As obrigações de sigilo e confidencialidade previstas nesta cláusula vincularão as Partes durante a vigência
            deste Contrato e continuarão na hipótese de seu término, por um período de até 03 (três) anos, contados a
            partir da data de seu encerramento, independentemente do motivo por que este venha a ocorrer. O seu
            desrespeito por parte de quaisquer delas possibilitará a imediata rescisão deste Contrato e implicará a
            responsabilização pelos danos comprovadamente causados em regular processo judicial.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            9.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>
                A CONTRATANTE aceita que a CONTRATADA faça uso de suas marcas, assim como de seu logo e/ou nome comercial
                e da referência do projeto que a CONTRATADA executará, e de forma expressa, irrevogável e gratuita, com a
                finalidade de identificá-la como “Cliente” da CONTRATADA.
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    9.3.1. &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    A autorização de uso será válida em todo território nacional e internacional, em todas as modalidades
                    de uso, desde que respeitada a legislação estabelecida no território da divulgação, sem trazer nenhum
                    prejuízo moral ou penal à CONTRATANTE.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    9.3.2. &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    As divulgações, incluem, mas não se limitam, às seguintes formas: uso permitido em seu site e qualquer
                    outra forma de mídia, inclusive em campanhas publicitárias, de cunho jornalístico, produções
                    fotográficas, audiovisuais, em blogs, sites, materiais impressos, programas televisivos, publicações
                    internas, redes sociais e qualquer outra forma de uso ou reprodução de imagem.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    9.3.3. &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    A CONTRATADA declara que a CONTRATANTE é detentora de todos os direitos autorais patrimoniais e morais
                    da marca, permitindo o seu uso para a publicação, por prazo indeterminado, sem que haja nenhum
                    desrespeito aos direitos autorais.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    9.3.4. &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Todos os modos de divulgação mencionados serão de custo da CONTRATADA, sendo que, as divulgações aqui
                    pretendidas serão de bom grado da CONTRATANTE, podendo, no momento de eventuais depoimentos e/ou
                    entrevistas, recursar-se, a qualquer momento, de colaborar para tanto. As divulgações pretendidas
                    deverão obedecer aos princípios da boa fé e dos bons costumes.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    9.3.5. &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Em caso de violação da presente cláusula, a CONTRATADA responderá pelos danos que comprovadamente der
                    causa, mediante apuração em devido processo legal.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Toda a documentação confidencial fornecida pelas Partes em função do presente instrumento, será, durante a
            vigência do Contrato, mantida sob a guarda e responsabilidade da Parte Receptora, devendo, a mesma, proceder
            à sua devolução nos casos de meios físicos, ou exclusão, no caso de meios digitais, por ocasião do término
            do Contrato ou caso a Parte Emissora solicite.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As regras de sigilo e confidencialidade subsistirão à rescisão ou ao término deste, independentemente do
            motivo, de qualquer outro instrumento que venha a ser celebrado entre as partes e/ou de qualquer vínculo que
            exista entre as Partes.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.6 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>
                As Partes utilizarão todas as medidas ao seu alcance para a proteção das Informações Confidenciais,
                obtendo de seus funcionários e/ou prepostos locados na prestação dos serviços, igual comprometimento às
                regras aqui estipuladas, para evitar que as INFORMAÇÕES CONFIDENCIAIS sejam, de qualquer modo, divulgados,
                revelados, publicados, vendidos, cedidos, locados, arrendados, ou de qualquer outra maneira alienados ou
                explorados por qualquer outro terceiro, devendo devolver as informações às quais tiver acesso por força de
                suas atividades.
            </p>

            <p>Parágrafo Primeiro - As obrigações e deveres especificados pelos itens acima da presente cláusula 11ª
                deste instrumento não se aplicam às informações que:</p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    a) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Sejam de domínio público, ou estejam disponíveis para o público de maneira geral antes de serem
                    recebidas pela Parte Receptora da Parte Emissora, ou que venham posteriormente a tornarem-se de
                    domínio público ou disponíveis de maneira geral para o público, antes de qualquer ação violadora da
                    Parte Receptora ou de um empregado ou agente da Parte Receptora;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    b) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Na forma da lei, mediante solicitação judicial ou em processo administrativo, contando que a Parte
                    Receptora notifique a Parte Emissora antes de tal revelação de modo a permitir que a Parte Emissora
                    apresente objeções ou procure amparo legal para impedir ou limitar o âmbito de tal revelação.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>


            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>


        <p>
        <strong> CLÁUSULA DÉCIMA– DA PROTEÇÃO DE DADOS PESSOAIS </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            10.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As partes se comprometem a, durante a vigência desse contrato, na relação comercial entre si ou com
            terceiros, respeitar as hipóteses autorizadoras de tratamento de dados previstas na Lei n. 13.709/2018 (Lei
            Geral de Proteção de Dados – LGPD).
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            10.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATANTE declara-se ciente e concorda de que a CONTRATADA não terá acesso a Dados Pessoais por meio
            dessa prestação de serviços, objeto desse contrato (Cláusula Primeira). Resta claro que a CONTRATADA apenas
            terá visualização da arquitetura do sistema proveniente dessa contratação.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            10.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>
                Para fins da relação contratual, as Partes comprometem-se a reter a menor quantidade possível de dados e
                registros e excluí-los:
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (i) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Tão logo atingida a finalidade de seu uso ou;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (ii) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Se encerrado o prazo determinado por obrigação legal, visando dar efetiva proteção aos dados coletados
                    de pessoas naturais que possam identificá-las ou torna-las identificáveis, utilizando-os de tais dados
                    tão-somente para os fins necessários à consecução do objeto deste Contrato, ou nos limites do
                    consentimento expressamente manifestado por seus respectivos titulares.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>


            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            10.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATANTE declara inequívoca ciência de que é de sua exclusiva responsabilidade a utilização dos dados
            obtidos por meio da prestação dos serviços da CONTRATADA, não sendo a CONTRATADA, em qualquer hipótese,
            responsabilizada pelo uso indevido por parte de CONTRATANTE e/ou terceiros, com relação a dados armazenados
            nos produtos contratados da Microsoft, em seus softwares e/ou bancos de dados. A CONTRATANTE reconhece que a
            Microsoft possui locais de armazenamento em nuvem em outros países, podendo se aplicar nestes casos, as
            responsabilidades desta prevista em legislação similar ou superior à proteção de dados pessoais.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            10.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Eventuais pedidos de exercício de direitos dos titulares de Dados Pessoais deverão ser direcionados à
            CONTRATANTE, por meio do endereço de e-mail lgpd@fcamara.com.br. Caso a CONTRATADA seja demanda por qualquer
            pessoa, autoridade ou entidade, pública ou privada, em razão de vazamento de dados resultantes da atuação da
            CONTRATANTE, fica garantido à CONTRATADA o direito à denunciação da lide, nos termos do artigo 125, II, do
            Código de Processo Civil.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>


        <p>
        <strong> CLÁUSULA DÉCIMA PRIMEIRA - DA RESILIÇÃO E DA RESCISÃO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes poderão resilir o contrato mediante aviso prévio de 90 (noventa dias), devendo a CONTRATANTE
            quitar todo e qualquer valor devido por consumos até o momento em que, de fato, encerrar a geração de novas
            cobranças dos serviços prestados.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>Constituem motivos para rescisão imediata do Contrato pela Parte prejudicada, independentemente de prévio
                aviso, a ocorrência de qualquer das situações abaixo:</p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    a) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Suspensão pelas autoridades competentes, da prestação do fornecimento contratado, em decorrência de
                    violação de dispositivos legais vigentes;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    b) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Decretação de falência da outra parte, recuperação judicial, instauração de concurso de credores ou
                    dissolução/liquidação de qualquer uma das Partes;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    c) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    A ocorrência de caso fortuito ou de força maior, regularmente comprovada, impeditiva da execução do
                    Contrato. Quando for possível a execução apenas parcial do contrato, a CONTRATANTE poderá decidir
                    entre o cumprimento parcial e a rescisão do Contrato.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            No caso de rescisão deste Contrato pela CONTRATANTE antes do prazo previsto da cláusula 9ª a CONTRATANTE
            arcará com o valor de 100% (cem por cento) conforme estipulado na cláusula 4ª, a serem pagos em até 10 (dez)
            dias do pedido de rescisão.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA DÉCIMA SEGUNDA - DA FORÇA MAIOR </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            12.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Os casos fortuitos ou de força maior serão excludentes de responsabilidade na forma do artigo 393 do Código
            Civil Brasileiro, desde que de fato influenciem nessa relação comercial.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            12.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A Parte que for afetada por caso fortuito ou motivo de força maior deverá notificar a outra, por escrito e
            em até 24 (vinte e quatro) horas, da extensão do fato e do prazo estimado durante o qual estará inabilitada
            a cumprir ou pelo qual será obrigada a atrasar o cumprimento de suas obrigações decorrentes do Contrato,
            obrigando-se ainda a notificar a outra parte quando cessados os seus efeitos.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            12.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Se a ocorrência do caso fortuito ou motivo de força maior prejudicar apenas parcialmente a execução das
            obrigações oriundas do Contrato por uma das Partes, a Parte afetada deverá cumprir as obrigações que não
            tiverem sido afetadas pela ocorrência do caso fortuito ou motivo de força maior, desde que ainda exista
            interesse na continuidade do contrato pela outra parte.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            12.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As interrupções no fornecimento ou nos serviços decorrentes de força maior ou caso fortuito implicarão,
            quando cessados os seus reflexos, no estabelecimento de novos prazos e condições contratuais a serem
            ajustadas entre as Partes mediante termo aditivo, desde que a continuidade da prestação do fornecimento seja
            de interesse de ambas as Partes.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>


        <p>
        <strong> CLÁUSULA DÉCIMA TERCEIRA - DAS DISPOSIÇÕES GERAIS </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            13.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Qualquer antecipação do cumprimento de obrigação por uma das Partes não obrigará a outra Parte a cumprir
            suas obrigações antes das datas previstas neste Contrato e suas Propostas Comerciais.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Na hipótese em que qualquer cláusula, termo ou disposição deste Contrato vier a ser declarada nula ou não
            aplicável, tal nulidade ou inexequibilidade não afetará quaisquer outras cláusulas, termos ou disposições
            aqui contidas, as quais permanecerão em pleno vigor e efeito.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Em todas as questões relativas ao Contrato, a CONTRATANTE e a CONTRATADA agirão como contratantes
            independentes. Nenhuma das Partes poderá declarar que possui qualquer autoridade para assumir ou criar
            qualquer obrigação, expressa ou implícita, em nome da outra Parte, nem representar a outra Parte como
            agente, funcionário, representante ou qualquer outra função. Fica desde já estabelecido que as Partes não
            têm nenhuma responsabilidade por dívidas e obrigações contraídas pela outra Parte, não podendo esta ou
            terceiros, utilizarem-se deste Contrato ou de qualquer outra razão para pleitear indenizações ou reembolsos.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Nenhuma das condições deste Contrato deve ser entendida como meio para constituir uma sociedade, joint
            venture, relação de parceria ou de representação comercial entre as Partes, nem ainda vínculo empregatício
            entre os empregados, prepostos, contratados e/ou subcontratados da CONTRATADA e da CONTRATANTE, sendo cada
            uma, única, integral e exclusivamente responsável por seus atos e obrigações.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Os serviços objeto do presente instrumento são contratados sem qualquer direito de exclusividade por
            quaisquer das Partes.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.6 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As cláusulas deste Contrato, consolidam o completo entendimento das Partes e prevalecem sobre quaisquer
            entendimentos firmados anteriormente a respeito do objeto ora contratado.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.7 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Fica expressa e irrevogavelmente estabelecido, que a tolerância com o atraso ou descumprimento de obrigações
            da outra Parte, bem como o não exercício, pelas Partes, de quaisquer direitos assegurados neste Contrato ou
            na lei em geral, não importará em novação contratual ou renúncia a qualquer desses direitos, podendo as
            Partes exercitá-los a qualquer tempo
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.8 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As cláusulas deste Contrato que por sua natureza tenham caráter perene, especialmente, mas não limitado às
            relativas a responsabilidades civis, trabalhistas, tributárias e previdenciária, bem como direitos de
            propriedade intelectual e confidencialidade, entre outras, permanecerão válidas mesmo após a rescisão do
            presente contrato.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.9 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O Contrato obriga, além das Partes contratantes, seus sucessores, qualquer que seja a forma de sucessão, em
            todos os direitos e obrigações assumidas por força do Contrato, obrigando-se ainda a CONTRATADA a não
            delegar ou transferir a terceiros, no todo ou em parte, os serviços objeto deste contrato, sem prévia e
            expressa anuência da CONTRATANTE.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.10 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes declaram, sob as penas da lei, que os procuradores e/ou representantes legais abaixo subscritos
            encontram-se devidamente nomeados na forma dos respectivos documentos de representação societários, com
            poderes para assumir as obrigações ora contraídas.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.11 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Para a execução deste contrato, nenhuma das partes poderá oferecer, dar ou se comprometer a dar a quem quer
            que seja, ou aceitar ou se comprometer a aceitar de quem quer que seja, tanto por conta própria quanto
            através de outrem, qualquer pagamento, doação, compensação, vantagens financeiras ou não financeiras ou
            benefícios de qualquer espécie que constituam prática ilegal ou de corrupção sob as leis de qualquer país,
            seja de forma direta ou indireta quanto ao objeto deste contrato ou de outra forma que não relacionada à
            este contrato, devendo garantir, ainda, que seus prepostos e colaboradores ajam da mesma forma.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.12 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATANTE fica desde logo ciente de que os serviços contratados pela CONTRATADA poderão sofrer
            interrupções periódicas para atualizações e reparos, bem como em razão de falhas corrigíveis, assumindo tal
            risco e abdicando integralmente de eventuais danos emergentes e lucros cessantes decorrentes da paralisação
            do programa.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.13 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATANTE declara ciência de que a CONTRATADA apenas faz a intermediação dos serviços disponibilizados
            pela Microsoft, sendo que qualquer problema na funcionalidade, qualidade e fornecimento do produto ou do
            serviço é de responsabilidade única e exclusiva da Microsoft, NÃO respondendo a CONTRATADA por qualquer
            prejuízo nesta esfera, como perdas e danos, lucros cessantes, danos materiais e morais, devendo ser
            pleiteados diretamente com a fornecedora (Microsoft), sendo de responsabilidade da CONTRATADA apenas a
            concessão da licença para utilização dos serviços.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.14 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Eventual responsabilidade imputável à CONTRATADA, desde que devidamente comprovada, em razão de quaisquer
            danos, de qualquer natureza, suportado pela CONTRATANTE, fica limitada a 3 (três) vezes do valor do
            contrato, correspondente aos valores efetivamente faturados nos 3 (três) últimos meses deste contrato, sem
            prejuízo da possibilidade de resolução do presente Contrato pela parte inocente.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA DÉCIMA QUARTA – DAS GARANTIAS DE PAGAMENTO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            14.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATANTE declara ciência de que a CONTRATADA poderá realizar uma avaliação de crédito para liberação de
            crédito aos serviços prestados da cláusula 1ª.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            14.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>
                Caso seja necessária a liberação de crédito, a CONTRATANTE deverá contratar garantias bancárias, tais
                quais:
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    a) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Fiança Bancária - Necessária a contratação de uma fiança bancária com banco de 1ª linha para garantia
                    do acordo comercial.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    b) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Comfort Letter - Caso haja alguma empresa detentora de cota/ação da CONTRATANTE, seja como uma holding
                    controladora ou uma empresa investidora pertencente ao mesmo grupo da CONTRATANTE, deverá ocorrer a
                    assinatura de uma Comfort Letter entre as Partes garantindo o pagamento do crédito em caso de qualquer
                    eventual descumprimento.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    c) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Aval de Sócios - Os sócios serão responsáveis solidários pelo valor compactuado na presente Proposta.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA DÉCIMA QUINTA - DO FORO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            15.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As partes convencionam que, qualquer controvérsia relativa à interpretação ou execução do presente contrato,
            ou de qualquer forma oriunda ou associada a ele, e que não seja resolvida de forma amigável entre as Partes,
            deverá ser dirimida de forma definitiva por Arbitragem, nos termos da Lei ° 9.307/96.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            15.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes desde já acordam, que o presente Contrato será assinado eletronicamente, via plataforma Clicksign,
            cuja validade para todos os fins é reconhecida pelos signatários, nos termos do artigo 10º, §2º, da MP
            2.200-2/2001. Ou, a critério da CONTRATANTE, poderá ser assinado fisicamente.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>


        <br>
    </td>
    </tr>
    <tr>
    <td align="center" height='60px'>
        <p style="text-align: center; margin-top: 50px;">
        São Paulo, {{contractstart}}
        </p>

        <p style="text-align: center; margin-top: 80px;">
        <span>
            ___________________________________________________<br>
            <strong>FCAMARA CONSULTORIA E FORMACAO EM INFORMATICA LTDA
            CONTRATANTE</strong>
        </span>
        </p>

        </br>
        <p style="text-align: center; margin-top: 80px;">
        <span>
            ___________________________________________________<br>
            <strong> {{companyname}} </strong>
            </br>
        </span>
        </p>
        </br>
        <p style="text-align: center; margin-top: 80px;">
        <span>
            <strong> CONTRATANTE </strong>
        </span>
        </p>
        </br>
    </td>
    </tr>
    <tr>
    <td>

        <!-- TESTEMUNHASSSS -->
        <p>
        <strong>Testemunhas:</strong>
        </p>

        <div class="testemunhas" style="margin: 0; text-align: left;">
        <table style="width: 100%;">
            <thead></thead>
            <tbody>
            <tr>
                <td>
                <span>
                    1. __________________________________<br>
                    Nome:<br>
                    CPF/MF:<br>
                </span>
                </td>
                <td>
                ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
                </td>
                <td>
                <span>
                    2. __________________________________<br>
                    Nome:<br>
                    CPF/MF:<br>
                </span>
                </td>
            </tr>
            </tbody>
        </table>
        </div>
    </td>
    </tr>
    </table>
`;

export default fcCloudVolumeContractModelEA_SCE_MPSA;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentCompanyTemplates/Volume12Meses.ts